import React, { ComponentProps, ReactElement } from 'react';
import { useDroppable, UseDroppableArguments } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

export const Droppable = ({
  children,
  items,
  strategy,
  ...props
}: UseDroppableArguments &
  Omit<ComponentProps<typeof SortableContext>, 'children'> & {
    children: (p: ReturnType<typeof useDroppable>) => ReactElement;
  }) => {
  const droppableProps = useDroppable(props);

  return (
    <SortableContext items={items} disabled={props?.disabled} strategy={strategy || verticalListSortingStrategy}>
      {children(droppableProps)}
    </SortableContext>
  );
};
